/**
 * Shared React Query key factory i hook-ovi za account/search (admin lista korisnika).
 * Deduplikuje zahtev kada AllUsersPanel mount-uje (npr. React Strict Mode).
 */

import { useQuery, useQueryClient } from '@tanstack/react-query';
import ApiService from '../ApiService';
import { API_ENDPOINTS } from '../endpoints';

/** Query key factory za account keš. */
export const accountKeys = {
  all: ['account'],
  search: () => [...accountKeys.all, 'search'],
};

const STALE_TIME_MS = 60 * 1000;

/**
 * React Query hook za admin pretragu svih korisnika (POST /account/search).
 *
 * @param {import('@tanstack/react-query').UseQueryOptions} [options] - Dodatne React Query opcije.
 * @returns {import('@tanstack/react-query').UseQueryResult<object[]>}
 */
export function useAccountSearchQuery(options = {}) {
  return useQuery({
    queryKey: accountKeys.search(),
    queryFn: async () => {
      const response = await ApiService.post(API_ENDPOINTS.ACCOUNT.SEARCH, {});
      return response.data?.users ?? [];
    },
    staleTime: STALE_TIME_MS,
    ...options,
  });
}

/**
 * Vraća QueryClient instancu (helper za cache operacije u account modulu).
 *
 * @returns {import('@tanstack/react-query').QueryClient}
 */
export function useAccountQueryClient() {
  return useQueryClient();
}
